import { render } from "./DeleteConfigurations.vue?vue&type=template&id=7ea098f2"
import script from "./DeleteConfigurations.vue?vue&type=script&lang=js"
export * from "./DeleteConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__